import { render, staticRenderFns } from "./OrderlineCompact.vue?vue&type=template&id=63cd0c3c"
import script from "./OrderlineCompact.vue?vue&type=script&lang=js"
export * from "./OrderlineCompact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports